import React from 'react'
import Select from 'react-select'

import 'react-select/dist/react-select.css'

const SELECTS = require('../Datas/Selects')

const SportsPassFormFilterAges = ({sportsPassFilterFilterActiveAges, OnChangeFilterAges}) => 
	<Select 
		className="generic-filters-select generic-filters-select-age sports-pass-filters-select sports-pass-filters-select-age" 
		name="sports-pass-filters-ages" 
		placeholder="Tous les âges" 
		options={SELECTS['ages']} 
		onChange={OnChangeFilterAges}
		value={sportsPassFilterFilterActiveAges}
		simpleValue
		clearable={false}
		searchable={false}
		aria-label="Sélectionner la tranche d'âge"
	/>

export default SportsPassFormFilterAges
